
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"36","viewBox":"0 0 40 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.5 0h-35C1.1 0 0 1.1 0 2.5v31C0 34.9 1.1 36 2.5 36h35.1c1.4 0 2.5-1.1 2.5-2.5v-31C40 1.1 38.9 0 37.5 0zm-35 1h35.1c.8 0 1.4.7 1.4 1.5v3.9H1V2.5C1 1.7 1.6 1 2.5 1zm35 34h-35c-.9 0-1.5-.7-1.5-1.5V7.4h38v26.1c0 .8-.6 1.5-1.5 1.5z"}}),_c('path',{attrs:{"d":"M13.3 9.4h3.4v3.4h-3.4zm5.1 0h3.4v3.4h-3.4zm5.1 0h3.4v3.4h-3.4zm5 0h3.4v3.4h-3.4zm5.1 0H37v3.4h-3.4zM3.2 14.5h3.4v3.4H3.2zm5.1 0h3.4v3.4H8.3zm5 0h3.4v3.4h-3.4zm5.1 0h3.4v3.4h-3.4zm5.1 0h3.4v3.4h-3.4zm5 0h3.4v3.4h-3.4zm5.1 0H37v3.4h-3.4zm-30.4 5h3.4v3.4H3.2zm5.1 0h3.4v3.4H8.3zm5 0h3.4v3.4h-3.4zm5.1 0h3.4v3.4h-3.4zm5.1 0h3.4v3.4h-3.4zm5 0h3.4v3.4h-3.4zm5.1 0H37v3.4h-3.4zM3.2 24.6h3.4V28H3.2zm5.1 0h3.4V28H8.3zm5 0h3.4V28h-3.4zm5.1 0h3.4V28h-3.4zm5.1 0h3.4V28h-3.4zm5 0h3.4V28h-3.4zm5.1 0H37V28h-3.4zm-30.4 5h3.4V33H3.2zm5.1 0h3.4V33H8.3z"}})])
          )
        }
      }
    